export const COLOR_PRIMARY = '#4dbbec';

export const COLOR_BACKGROUND_LIGHTER = '#EDF2F3';
export const COLOR_BACKGROUND_LIGHT = '#dbe3e5';
export const COLOR_TABLE_BORDER = '#C5CCCE';

export const COLOR_TYPOGRAPHY_DARK = '#426B7A';
export const COLOR_TYPOGRAPHY_LIGHTER = '#00BFF2';
export const COLOR_TYPOGRAPHY_LIGHT = '#4dbbec';
export const COLOR_TYPOGRAPHY_ERROR = '#e73737';

export const COLOR_OK = '#00E779';
export const COLOR_WARNING = '#FFA200';
export const COLOR_ERROR = '#FF4700';
